module.exports = __webpack_public_path__ + "static/media/DSC_0236.9f99ec47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0236.jpg
// module id = 571
// module chunks = 0